/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CoverCombinationType;

(function (CoverCombinationType) {
  CoverCombinationType["PACKAGE"] = "package";
  CoverCombinationType["PICK_CHOOSE"] = "pick_choose";
})(CoverCombinationType || (CoverCombinationType = {}));